// import baseRequest from "./baseRequest";
import axios from "axios";
import baseURL from "./configvars";

const registerUser = async (data) => {
  try {
    const response = await axios.post(`${baseURL}/api/accounts/register/`, data);
    return response;
  } catch (error) {
    return error;
  }
};

const loginUser = async (data) => {
  try {
    const response = await axios.post(`${baseURL}/api/accounts/token/`, data);
    localStorage.setItem("access_token", response.data.access);
    localStorage.setItem("refresh_token", response.data.refresh);
    return response;
  } catch (error) {
    return error;
  }
};

const logoutUser = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};

const bookAppointment = async (data) => {
  try {
    const response = await axios.post(
      `${baseURL}/api/accounts/appointments/`,
      data
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export { registerUser, loginUser, logoutUser, bookAppointment };